import { HYDRATE } from "next-redux-wrapper";
import { ActionsAppliedPromotion } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeAppliedPromotions(state = initialState, action) {

	switch (action.type) {

	case HYDRATE: {

		return { ...state, ...action.payload.storeAppliedPromotions };

	}
	case ActionsAppliedPromotion.LOAD_GET_APPLIED_PROMOTION:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsAppliedPromotion.RES_GET_APPLIED_PROMOTION:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsAppliedPromotion.ERR_GET_APPLIED_PROMOTION:
		return {
			...state, data: {}, status: "fetch_error", message: "Error...",
		};
	default: {

		return {
			...state,
		};

	}

	}

}

export default storeAppliedPromotions;
